exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Written by Ye Liu */\n\n.MuiFab-primary {\n    background-color: #89ca92 !important;\n}\n\n.MuiSpeedDialAction-button {\n    color: white !important;\n}\n\n.MuiTooltip-tooltip {\n    background-color: #424242 !important;\n}", ""]);
